export default "/wp-content/themes/onnit/script/cart/dist/nmiOverrideMobile-d726f291.png";